export default __webpack_public_path__ + "static/media/UniversLTStd-LightCnObl.e1c249a2.otf";